module.exports = __webpack_public_path__ + "img/大雅廚具 logo.97775812.jpg";